import "./App.css";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { SignIn } from "./pages/SignIn";
import { FirebaseProviderApp } from "./firebase/context";
import Error from "./pages/Error";

import Navigation from "./Navigation/Navigation";
import { UpTest } from "./pages/User/UpTest";
import PrivateRoute from "./utils/PrivateRoute.jsx";
function App() {
  return (
    <div className="App">
      <FirebaseProviderApp>
        <BrowserRouter>
          <Switch>
            <Route exact path="/login" component={SignIn} />
            <Route exact path="/uptest" component={UpTest} />
            <PrivateRoute>
              <Navigation />
            </PrivateRoute>
            <Route path="*" component={Error} />
          </Switch>
        </BrowserRouter>
      </FirebaseProviderApp>
    </div>
  );
}

export default App;
